import { autoinject } from 'aurelia-framework';
import { ServiceInvoiceWashWasteNetTypeProduct } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class ServiceInvoiceWashWasteNetTypeProductService extends BaseApiService<ServiceInvoiceWashWasteNetTypeProduct> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, ServiceInvoiceWashWasteNetTypeProduct);
  }

  getAllWithProduct(erpSystemId: number) {
    const query = `?$expand=WashProduct,WasteProduct,NetType&$filter=WashProduct/ProductSource eq ${erpSystemId} or WasteProduct/ProductSource eq ${erpSystemId}`;

    return this.get(query) as unknown as Promise<ServiceInvoiceWashWasteNetTypeProduct[]>;
  }
}
